import React     from "react";
import PropTypes from "prop-types";
import style     from '../ModalBoxWrapper.module.less';

function ModalBoxClose(props) {
    return <i onClick={props.onClose} className={"icon -icon-close-full " + style.modalClose} />;
}

ModalBoxClose.propTypes    = {
    onClose: PropTypes.func,
};
ModalBoxClose.defaultProps = {
    onClose: () => {},
};

export default ModalBoxClose;
